import { useTranslation } from "react-i18next";

import { FormikProps } from "formik";

import { AssetDocumentZone, PendingDocumentMove } from "../../../../../api/ClientFileApi";
import { ClientFileQueryKey } from "../../../../../query/clientFileQueryKeys";
import { AssetDocumentsSection } from "../../../../components/asset-documents-section/AssetDocumentsSection";
import { useAssetInventoryDocuments } from "../../../../hooks/useAssetInventoryDocuments";
import { AssetOwnClaimsFormValues } from "../../OwnClaimsView.types";

const SECTION = "clients.client.debtSettlement.assetInventory.ownClaimsTab.documents";

interface Props {
  clientId: string;
  formik: FormikProps<AssetOwnClaimsFormValues>;
  onAddMove: (move: PendingDocumentMove) => void;
  onCancelMove: (documentId: string) => void;
}

export function OwnClaimDocumentsSection({ clientId, formik, onAddMove, onCancelMove }: Props) {
  const { t } = useTranslation();
  const { documents, markRead, deleteDocument, isBusy } = useAssetInventoryDocuments(clientId, {
    queryKey: ClientFileQueryKey.AssetInventoryOwnClaimDocuments,
    getDocuments: (api, params) => api.getAssetInventoryOwnClaimDocuments(params),
    getDeleteDocument: (api) => api.deleteAssetInventoryOwnClaimDocument?.bind(api),
  });

  return (
    <AssetDocumentsSection
      clientId={clientId}
      formik={formik}
      fieldName="ownClaimDocuments"
      zone={AssetDocumentZone.OwnClaims}
      title={t(`${SECTION}.title`)}
      uploadHint={t(`${SECTION}.uploadHint`)}
      documents={documents}
      onMarkRead={markRead}
      onDelete={deleteDocument}
      isBusy={isBusy}
      onAddMove={onAddMove}
      onCancelMove={onCancelMove}
    />
  );
}
